import * as api from "../Api";

export const getMonthlyExpires = () => async (dispatch) => {
  try {
    const { data } = await api.getMonthlyExpires();
    dispatch({ type: "GET_MONTHLY_EXPIRES", payload: data });
  } catch (error) {
    dispatch({ type: "LOAD_FAILED", failed: "GET_MONTHLY_EXPIRES" });
  }
};
